// Generated by @knighted/css/generate-types
// Do not edit.

export { knightedCss } from './auto_stable_showcase.js?knighted-css'

export * from './auto_stable_showcase.js'

export const stableSelectors = {
  "actions": "knighted-actions",
  "button": "knighted-button",
  "copy": "knighted-copy",
  "kicker": "knighted-kicker",
  "meta": "knighted-meta",
  "panel": "knighted-panel",
  "title": "knighted-title",
} as const

export type KnightedCssStableSelectors = typeof stableSelectors
export type KnightedCssStableSelectorToken = keyof typeof stableSelectors
